function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconFallbackOrg = function SvgIconFallbackOrg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    y: 0.734375,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D9DCE6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 22.1811V14.6889C8.5 14.2313 8.70179 13.797 9.0515 13.5019L14.8997 8.56684C15.4716 8.08426 16.3063 8.07804 16.8853 8.55206L22.9307 13.5013C23.291 13.7962 23.5 14.2374 23.5 14.7031V22.1811C23.5 23.0389 22.8046 23.7343 21.9468 23.7343H18.6631V16.6933H13.6846V23.7343H10.0532C9.19538 23.7343 8.5 23.0389 8.5 22.1811Z",
    fill: "white"
  }));
};
export default SvgIconFallbackOrg;